/**
 * Image class
 * @private
 */
/* eslint-disable */
export class Image {
}
